export default {
    items() {
        if (this.offersData && this.offersData.items) {
            return this.offersData.items;
        }
        return [];
    },
    theApiResource() {
        if (this.offersData && this.offersData.apiResource) {
            return this.offersData.apiResource;
        }
        return '';
    },
};
